if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get("theme-header")) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
      this._scrollTicking = false;
      this._boundOnScroll = this._onScroll.bind(this);
      this._cachedAnnouncementBar = null;
    }
    connectedCallback() {
      this.header_section = document.querySelector(".header-section");
      this.menu = this.querySelector("#mobile-menu");
      this.toggle = this.querySelector(".mobile-toggle-wrapper");
      document.addEventListener("keyup", (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === "ESCAPE") {
            this.toggle.removeAttribute("open");
            this.toggle.classList.remove("active");
          }
        }
      });
      if (this.classList.contains("header-sticky--active")) {
        document.body.classList.add("header-sticky--active");
      }
      document.addEventListener("DOMContentLoaded", this.setTransparentClass.bind(this));

      this.toggle.querySelector(".mobile-toggle").addEventListener("click", (e) => {
        if (this.toggle.classList.contains("active")) {
          e.preventDefault();
          document.body.classList.remove("overflow-hidden");
          this.toggle.classList.remove("active");
          this.closeAnimation(this.toggle);
          window.dispatchEvent(new Event("scroll"));
        } else {
          this.classList.add("is-sticky");
          this.querySelector(".full-mega-menu").classList.add("is-active");
          document.body.classList.add("overflow-hidden");
          setTimeout(() => {
            this.toggle.classList.add("active");
          });
        }
      });

      // Consolidated scroll handler using requestAnimationFrame to prevent layout thrashing
      window.addEventListener("scroll", this._boundOnScroll, {passive: true});

      // Cache announcement bar reference
      this._cachedAnnouncementBar = document.querySelector(".announcement-bar-section");
      if (this._cachedAnnouncementBar) {
        this.setAnnouncementHeight();
        window.addEventListener(
          "resize",
          debounce(() => this.setAnnouncementHeight(), 150),
          {passive: true}
        );
      }

      // Initial scroll values
      this._onScrollFrame();

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector(".header-mobile-navigation");

        if (this.mobile_nav && this.classList.contains("transparent--true")) {
          this.mobile_nav.classList.add("is-fixed");
        }
      }, 100);
      // Buttons.
      this.menu
        .querySelectorAll("summary")
        .forEach((summary) =>
          summary.addEventListener("click", this.onSummaryClick.bind(this))
        );
      this.menu
        .querySelectorAll(".parent-link-back--button")
        .forEach((button) =>
          button.addEventListener("click", this.onCloseButtonClick.bind(this))
        );
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this._boundOnScroll);
    }
    _onScroll() {
      if (!this._scrollTicking) {
        this._scrollTicking = true;
        requestAnimationFrame(() => {
          this._onScrollFrame();
          this._scrollTicking = false;
        });
      }
    }
    _onScrollFrame() {
      // Batch all DOM reads together first
      const headerRect = this.header_section.getBoundingClientRect();
      const headerHeight = this.clientHeight;
      const scrollY = window.scrollY;

      // Then batch all DOM writes
      this._updateStickyClass(headerRect, scrollY);
      document.documentElement.style.setProperty(
        "--header-offset",
        headerRect.top + "px"
      );
      document.documentElement.style.setProperty("--header-height", headerHeight + "px");
    }
    _updateStickyClass(headerRect, scrollY) {
      const megaMenus = Array.from(
        document.querySelectorAll(".full-mega-menu--menu-primary")
      );
      const isPage = megaMenus.some(
        (menu) => menu.getAttribute("data-path") === window.location.pathname
      );
      const isHomePage = document.body.classList.contains("template-index") || isPage;
      if (this.classList.contains("header-sticky--active")) {
        let offset = parseInt(headerRect.top, 10) + document.documentElement.scrollTop;
        const shouldStick = scrollY >= offset && scrollY > 0;
        this.classList.toggle("is-sticky", shouldStick);

        isHomePage &&
          this.querySelector(".full-mega-menu").classList.toggle(
            "is-active",
            shouldStick
          );
        document
          .querySelector(".product-information")
          ?.classList.toggle("is-sticky", shouldStick);
      }
    }
    setAnnouncementHeight() {
      if (this._cachedAnnouncementBar) {
        const h = this._cachedAnnouncementBar.clientHeight;
        document.documentElement.style.setProperty("--announcement-height", h + "px");
      }
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest(".link-container");
      const isOpen = detailsElement.hasAttribute("open");
      if (this.querySelector(".parent-link-back--button")) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove("menu-opening");
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    setTransparentClass() {
      this.template_header = document.querySelector(".template-header");

      if (
        this.template_header &&
        this.template_header.classList.contains("template-header--has-image-true") &&
        this.template_header.dataset.sectionIndex == 1
      ) {
        this.classList.remove("transparent--false");
        this.classList.add("transparent--true");
      }
    }
  }
  customElements.define("theme-header", ThemeHeader);
}
